<template>
  <div class="teacher-layout" :class="{ 'fixed-layout': !isHomePage }">
    <!-- 蓝色背景区域 -->
    <div class="blue-background"></div>
    
    <!-- 顶部导航栏 -->
    <TeacherHeader />
    
    <div class="teacher-main">
      <!-- 侧边栏 -->
      <TeacherSidebar ref="sidebarRef" />
      
      <!-- 主要内容区域 -->
      <div class="teacher-content" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
        <div class="content-container" :class="{ 'fixed-content': !isHomePage }">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import TeacherHeader from './components/TeacherHeader.vue'
import TeacherSidebar from './components/TeacherSidebar.vue'

const route = useRoute()
const sidebarRef = ref(null)
const sidebarCollapsed = ref(false)

// 判断是否为首页
const isHomePage = computed(() => {
  return route.path === '/teacher/home'
})

// 监听侧边栏收缩状态
onMounted(() => {
  if (sidebarRef.value) {
    watch(() => sidebarRef.value.isCollapse, (newVal) => {
      // 添加0.4秒延迟，等待侧边栏动画完成后再扩展主体页面
      setTimeout(() => {
        sidebarCollapsed.value = newVal
      }, 400)
    }, { immediate: true })
  }
})

// 监听路由变化，控制body滚动（仅在教师端生效）
watch(isHomePage, (newVal) => {
  // 确保当前路由是教师端路由
  if (route.path.startsWith('/teacher')) {
    if (newVal) {
      // 首页：允许body滚动
      document.body.style.overflow = 'auto'
      console.log('教师首页：设置body滚动为auto')
    } else {
      // 非首页：禁用body滚动
      document.body.style.overflow = 'hidden'
      console.log('教师非首页：设置body滚动为hidden')
    }
  }
}, { immediate: true })

// 监听路由变化，当离开教师端时恢复body滚动
watch(() => route.path, (newPath, oldPath) => {
  // 如果从教师端路由离开到非教师端路由
  if (oldPath && oldPath.startsWith('/teacher') && !newPath.startsWith('/teacher')) {
    document.body.style.overflow = 'auto'
    console.log('离开教师端：恢复body滚动为auto')
  }
})

// 组件卸载时恢复body滚动
onUnmounted(() => {
  // 只有在教师端路由下才恢复，避免影响其他页面
  if (route.path.startsWith('/teacher')) {
    document.body.style.overflow = 'auto'
    console.log('教师布局组件卸载：恢复body滚动为auto')
  }
})
</script>

<style scoped>
.teacher-layout {
  min-height: 100vh;
  background-color: #f5f7fa;
  position: relative;
  overflow-x: hidden;
}

/* 固定布局样式 - 用于非首页 */
.teacher-layout.fixed-layout {
  height: 100vh;
  overflow: hidden;
}

/* 蓝色背景区域 */
.blue-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 10rem;
  background-color: #307CF4;
  z-index: 1;
}

.teacher-main {
  display: flex;
  min-height: calc(100vh - 60px);
  margin-top: 60px;
  position: relative;
  z-index: 2;
}

.teacher-content {
  flex: 1;
  padding: 10px 0 0 20px;
  background-color: transparent;
  min-width: 0;
}

/* 白色内容容器 */
.content-container {
  background-color: white;
  border-radius: 12px 0 0 0; /* 上圆角 */
  padding: 20px;
  height: calc(100vh - 80px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  overflow-x: auto;
  margin-top: 10px;
}

/* 固定内容容器样式 - 用于非首页 */
.content-container.fixed-content {
  height: calc(100vh - 80px);
  overflow-y: auto;
  overflow-x: auto;
}

@media (max-width: 768px) {
  .teacher-content {
    margin-left: 0;
    padding: 10px;
  }
  
  .content-container {
    border-radius: 12px 12px 0 0;
  }
}
</style>
